<!--
  @component
  
  A very basic page, will display a `Content` object once it is loaded.
-->
<script lang="ts">
  import ContentContainer from "../components/content-box-system/ContentContainer.svelte";
  import ContentSection from "../components/content-box-system/ContentSection.svelte";
  import { loadContent } from "../loader";
  import type { SLAKRoute } from "../routes";

  export let route: SLAKRoute;
  if (route.kind !== "internal +navbar") {
    throw new Error("Can't display this kind of Route.");
  }
  const {
    content: { main, side },
  } = route;

  const hasSideContent = !!side && !!side.length;
</script>

<main>
  <ContentContainer classNames="pure-g">
    <div class={hasSideContent ? `pure-u-1-1 pure-u-md-3-4` : `pure-u-1-1`}>
      {#each main as section}
        <ContentSection content={loadContent(section.file, section.options)} />
      {/each}
    </div>
    {#if hasSideContent}
      <div class="pure-u-1-1 pure-u-md-1-4">
        {#each side as section}
          <ContentSection
            content={loadContent(section.file, section.options)}
          />
        {/each}
      </div>
    {/if}
  </ContentContainer>
</main>

<style></style>
